module.exports = __webpack_public_path__ + "static/img/section-1-image.66a93230.png";